class MyContents {

    constructor() {

        // Plantillas
        this._template = null;
        this._searchedResultsTemplate = null;

        // Datos de la clase
        this.open = false;
        this._filteredDocuments = null;
        this._searchedDocuments = null;
        this._publishedDocuments = null;
        this._draftDocuments = null;

        this._loadTemplates();

    }

    _loadTemplates() {
        this._template = Handlebars.compile($("#myContentsScreen").html());
        this._searchedResultsTemplate = Handlebars.compile($("#searchedResults").html());
    }

    _enableHandlers() {
        $("div.my-contents-close-button").on("click.closeMyContents", this._onCloseMyContents.bind(this));
        $("div.my-contents-filters-button-open").on("click.openFilters", this._onOpenFilters.bind(this));
        $("div.my-contents-filters-button-close").on("click.closeFilters", this._onCloseFilters.bind(this));
        $("div.my-contents-filter").on("click.filter", this._onFilter.bind(this));
        $("form.my-contents-searcher").on("submit.search", this._onSearch.bind(this));
        $("ul.my-content-draft-documents").on("click.openDraftDocument", ".mycontents-view", this._onOpenDraftDocument.bind(this)); // Controlador con evento delegado para editar un borrador
        $("ul.my-content-published-documents").on("click.openPublishedDocument", ".mycontents-view", this._onOpenPublishedDocument.bind(this)); // Controlador con evento delegado para abrir la vista detalles del documento publicado
    }

    _onCloseMyContents(event) {

        const documentationNew = documentationScreenController.documentationNew;

        baseController.closeStack();

        if (documentationNew.displayedDocumentTypes) {
            documentationNew.onToggleNewButton();
        }

        window.scrollTo(0, documentationNew.lastYScrollPosition);

        this.clearData();

    }

    _onOpenFilters(event) {

        const $openFiltersButton = $(event.currentTarget);
        const $filtersBar = $("div.my-contents-filters-bar");
        const $searcher = $("form.my-contents-searcher");
        const $filters = $("div.my-contents-filters");
        const $wrapper = $("div.wrapper").last();
        const documentationFilters = documentationScreenController.documentationFilters;
        let filtersAnimatonHeight = null;
        let searchInputFreeWidth = null;

        // Al desplegar los filtros se olculta el boton (Icono de buscar) y se muestran los filtros pero sin opacidad (para poder calcular medidas)
        $openFiltersButton.hide();
        $filtersBar.show();

        // Se obtienen las medidas para saber si el buscador cabe o no en la misma fila que los filtros.
        searchInputFreeWidth = DocumentationUtils.calculateSearchInputWidth("my-contents");

        // Dependiendo de si el buscador cabe o no en la misma fila la altura de la animacion que baja los filtros es mayor o menor (los filtros estaran en 1 linea o en 2)
        if (searchInputFreeWidth >= $wrapper.width() * documentationFilters.defaultInputSearchMinWidth) {
            filtersAnimatonHeight = $searcher.outerHeight();
        } else {
            filtersAnimatonHeight = $searcher.outerHeight() + $filters.outerHeight();
        }

        // Se despliega la cortina donde iran los filtros
        $filtersBar.animate({height: filtersAnimatonHeight}, documentationFilters.defaultOpenCloseAnimationSpeed);
        // Se hacen opacos con una animacion
        $filtersBar.fadeTo(documentationFilters.defaultFadeToAnimationSpeed, 1);

    }

    _onCloseFilters(event) {

        function _onCloseAnimationComplete() {
            $filtersBar.hide();
            $openFiltersButton.show();
        }

        const $openFiltersButton = $("div.my-contents-filters-button-open");
        const $filtersBar = $("div.my-contents-filters-bar");
        const documentationFilters = documentationScreenController.documentationFilters;

        // Al cerrar los filtros se hace invisible el contenido
        $filtersBar.fadeTo(documentationFilters.defaultFadeToAnimationSpeed, 0);
        // Y subimos la cortina de nuevo hasta la altura que tenia el boton de mostrar filtros
        $filtersBar.animate({height: $openFiltersButton.css("height")}, documentationFilters.defaultOpenCloseAnimationSpeed, _onCloseAnimationComplete);

    }

    _onOpenDraftDocument(event) {

        const $this = $(event.currentTarget);
        const documentId = $this.data("document");
        const document = _.find(this._draftDocuments, function(draft) { return draft.id === documentId });
        const documentationPublish = documentationScreenController.documentationPublish;
        const documentationNew = documentationScreenController.documentationNew;
        let documentType = "";

        // Asegurar que el tipo del documento que se le envia a la pantalla de publicacion para editar el documento coincide con la lista del documentationNew
        switch (document.type) {

            case "ARTICLE":
                documentType = documentationNew.ARTICLE;
                break;

            case "IMAGE":
                documentType = documentationNew.IMAGE;
                break;

            case "VIDEO":
                documentType = documentationNew.VIDEO;
                break;

            case "DOC":
            case "PDF":
                documentType = documentationNew.DOCUMENT;
                break;

            case "URL":
                documentType = documentationNew.EXTERNAL;

        }

        if (!documentationScreenController.documentationTags) {
            api.getDocumentTags(function (response) {
                documentationScreenController.documentationTags = response.result.tags;
            }, false);
        }

        if (!docSocket) {
            docSocket = api.quizSoquet();
        }

        documentationPublish.drawEnterTransitionScreen();

        setTimeout(function() {
            documentationPublish.initialize(documentType, document.url, document);
        }, 2000);

    }

    _onOpenPublishedDocument(event) {

        const $this = $(event.currentTarget);
        const documentId = $this.data("document");
        const document = documentationScreenController.getDocument(documentId);
        const parentFolder = documentationScreenController.getParentFolder(documentId, documentationScreenController.documentation);

        // Antes de abrir el documento mirar si se tiene el socket, si no se tiene (se esta abriendo el contenido desde fuera de la pestaña documentacion) hay que obtenerlo
        if (!docSocket) {
            docSocket = api.quizSoquet();
        }

        documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

    }

    _onFilter(event) {

        const $this = $(event.currentTarget);
        const $filtersContainer = $("div.my-contents-filters");
        const filteredDocuments = DocumentationUtils.applyDocumentationFilters($this, $filtersContainer, this._publishedDocuments);
        const $activeFilters = $filtersContainer.find(".filterEnabled");

        if ($activeFilters.length === 0) {
            this._filteredDocuments = null;
        } else {
            this._filteredDocuments = filteredDocuments;
        }

        this._drawFiltersResults();

    }

    _onSearch(event) {

        function _filterCondition(document) {
            return document.name.indexOf(searchInputValue) >= 0;
        }

        event.preventDefault();

        const $this = $(event.currentTarget);
        const $searchInput = $this.find("input.my-contents-searchbar");
        const searchInputValue = $searchInput.val();

        if (searchInputValue.trim() === "") {
            this._searchedDocuments = null;
        } else {
            this._searchedDocuments = _.filter(this._publishedDocuments, _filterCondition);
        }

        this._drawFiltersResults();


    }

    _drawScreen() {

        const context = {
            world: world,
            publishedDocuments: this._publishedDocuments,
            draftDocuments: this._draftDocuments,
            searchFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_SEARCH"],
            filters: {
                classSelector: "my-contents-filter",
                playFilterId: "my-contents-sort-play",
                playFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_PLAY"],
                testFilterId: "my-contents-sort-test",
                testFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_TEST"],
                completedFilterId: "my-contents-sort-completed",
                completedFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NOT_SEEN"],
                favouriteFilterId: "my-contents-sort-favourite",
                favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                newFilterId: "my-contents-sort-new",
                newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"],
                shareFiltersId: "my-contents-sort-share",
                shareFiltersIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_SHARE_LINK"],
                ratingFilterId: "my-contents-sort-rating",
                ratingFiltersIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_RATE"],
            },
            documentationFavorite: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_FAVORITE"],
            documentationShareChat: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE_CHAT"],
            documentationShare: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
            documentationPlay: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_PLAY"],
            documentationComment: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_COMMENT"],
            documentationRate: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_RATE"],
        };

        baseController.stackSimpleContent(this._template, context, 'CONTENT');
        documentationScreenController.slideActionsDocumentList.initialize();

    }

    _drawFiltersResults() {

        let filtersResults = [];

        // Elige de que lista ha de mostrar los resultados
        // Si solo se utiliza el filtro -> _filteredDocuments
        // Si solo se utiliza el buscador -> _searchedDocuments
        // Si se utilizan ambas cosas -> _.intersectionBy
        if (this._filteredDocuments && this._searchedDocuments) {
            filtersResults = _.intersectionBy(this._filteredDocuments, this._searchedDocuments, "id");
        } else if (this._filteredDocuments) {
            filtersResults = this._filteredDocuments;
        } else if (this._searchedDocuments) {
            filtersResults = this._searchedDocuments;
        } else {
            filtersResults = this._publishedDocuments;
        }

        const $publishedDocumentsList = $("ul.my-content-published-documents");
        const $resultsText = $(".publications-tab > div.total-results");
        const context = {
            filterType: "myContents",
            world: world,
            documents: filtersResults,
            filters: {
                playFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_PLAY"],
                testFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_TEST"],
                favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"]
            }
        }

        $publishedDocumentsList.html(this._searchedResultsTemplate(context));
        $resultsText.text(sprintf(Translator.trans("TR_X_PUBLICACIONES"), filtersResults.length));

    }

    initialize() {

        function _onGetUserDocumentationSuccess(response) {

            _.forEach(response.result.documents, function(document) {
                DocumentationUtils.formatDocumentParameters(document)
            });

            if (response.result.published) {
                that._publishedDocuments = response.result.documents;
            } else {
                that._draftDocuments = response.result.documents;
            }

            if (that._publishedDocuments && that._draftDocuments) {
                that._drawScreen();
                that._enableHandlers();

                const $body = $("body");
                const $window = $(window);

                $body.removeClass("no-scroll");
                $window.scrollTop(0);

            }

        }

        const that = this;

        api.getUserDocumentation(world.token, true, _onGetUserDocumentationSuccess);
        api.getUserDocumentation(world.token, false, _onGetUserDocumentationSuccess);

    }

    clearData() {

        this._filteredDocuments = null;
        this._searchedDocuments = null;
        this._publishedDocuments = null;
        this._draftDocuments = null;

    }

}
